<template>
  <div>
    <v-row align="center">
      <v-col cols="12">
        <v-range-slider
          label="Výber obdobia"
          v-model="filterORange"
          step="1"
          :min="minYear"
          :max="maxYear"
          ticks="always"
          tick-size="4"
          thumb-label="always"
        ></v-range-slider>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <bar-chart
          :chart-data="grafValues(1)"
          :options="grafOptions(1)"
        ></bar-chart>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <scatter-chart
          :chart-data="grafValues(2)"
          :options="grafOptions(2)"
        ></scatter-chart>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import * as moment from "moment"
//import * as Miscella from "@/plugins/miscella.js"
//import * as Colors from "../plugins/colors.js"
import BarChart from "./BarChart.js"
import ScatterChart from "./ScatterChart.js"

export default {
  data: function() {
    return {
      loading: false,
      filterORange: [this.minYear, this.maxYear],
      grafData: [],
      merania: []
    }
  },
  components: { BarChart, ScatterChart },
  props: {
    bod: {
      type: Object,
      required: true
    },
    minYear: {
      type: Number,
      required: true
    },
    maxYear: {
      type: Number,
      required: true
    }
  },
  computed: {},
  watch: {
    filterORange: {
      immediate: true,
      handler: function() {
        this.show()
      }
    },
    bod: {
      immediate: true,
      handler: function() {
        this.readMer()
      }
    }
  },
  methods: {
    grafValues: function(aIndex) {
      let filteredMerGeos = this.filterMerGeos(this.merania)
      let ret = ""
      if (aIndex === 1) {
        let dataset = {
          label: this.bod.ZNMB,
          data: this.grafData.map(function(i) {
            return { x: i.Datum, y: i.HorPosun }
          }),
          backgroundColor: "#336600",
          borderColor: "#336600",
          borderWidth: "1",
          fill: "true"
        }
        //posledne data musia byt null
        dataset.data.push({ x: "12.31." + this.filterORange[1], y: null })
        ret = { datasets: [dataset] }
      }
      if (aIndex === 2) {
        ret = {
          datasets: [
            {
              label: "Poloha",
              data: filteredMerGeos.map(function(i) {
                return { x: i.X, y: i.Y }
              }),
              backgroundColor: "#ff0000",
              borderColor: "#ff0000",
              pointRadius: "1",
              borderWidth: "1",
              pointStyle: "circle",
              showLine: true,
              fill: "false"
            }
          ]
        }
      }
      return ret
    },
    grafOptions: function(aIndex) {
      let ret = ""
      switch (aIndex) {
        case 1:
          ret = {
            maintainAspectRatio: false,
            responsive: true,
            title: {
              display: true,
              text: `Zobrazenie vývoja pohybovej aktivity za obdobie (${this.filterORange[0]} - ${this.filterORange[1]}) - horizontálny posun`
            },
            scales: {
              xAxes: [
                {
                  type: "time",
                  distribution: "series",
                  time: {
                    unit: "month"
                  }
                }
              ]
            }
          }
          break
        case 2:
          ret = {
            maintainAspectRatio: false,
            responsive: true,
            title: {
              display: true,
              text: `Zobrazenie vývoja pohybovej aktivity na bode za obdobie (${this.filterORange[0]} - ${this.filterORange[1]})`
            },
            legend: { display: true, position: "top" },
            scales: {
              xAxes: [
                {
                  display: true,
                  position: "top",
                  scaleLabel: {
                    display: true,
                    labelString: "X"
                  }
                }
              ],
              yAxes: [
                {
                  display: true,
                  position: "right",
                  scaleLabel: {
                    display: true,
                    labelString: "Y"
                  }
                }
              ]
            }
          }
          break
        default:
          break
      }
      return ret
    },
    urlFetch: function() {
      let url = "/chart/geo2"
      url += "?bodID=" + this.bod.ID
      url += "&rokOd=" + this.filterORange[0]
      url += "&rokDo=" + this.filterORange[1]
      return url
    },
    show: async function() {
      this.grafData = []
      try {
        this.loading = true
        let response = await this.$axios.get(this.urlFetch())
        if (response.status === 200) {
          this.grafData = response.data.data
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      } finally {
        this.loading = false
      }
    },
    readMer: async function() {
      this.merania = []
      try {
        this.loading = true
        let response = await this.$axios.get("/mer_geo/" + this.bod.ID)
        if (response.status === 200) {
          this.merania = response.data
          this.merania.sort((a, b) =>
            moment(a.Datum, "YYYY-MM-DDTHH:mm:ss").isBefore(
              moment(b.Datum, "YYYY-MM-DDTHH:mm:ss")
            )
              ? -1
              : 1
          )
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      } finally {
        this.loading = false
      }
    },
    filterMerGeos: function(merGeos) {
      return merGeos.filter(
        i =>
          moment(i.Datum).isAfter(moment([this.filterORange[0]])) &&
          moment(i.Datum).isBefore(moment([this.filterORange[1]]))
      )
    }
  },
  mounted: function() {}
}
</script>
